import * as React from 'react'

import { config } from '../../../common/config'

import * as styles from './emptyResultsPlaceholder.module.css'

interface IProps {
  heading: string | React.ReactNode
  subHeading: string | React.ReactNode
}

const EmptyResultsPlaceholder = ({ heading, subHeading }: IProps) => {
  return (
    <div className={styles.root}>
      <div>
        <img
          alt={''}
          role="presentation"
          src={`${config.assets.PUBLIC_PATH}/images/saucer.png`}
          className={styles.flyingSaucer}
        />
      </div>
      <div>
        <h2 className={styles.heading}>{heading}</h2>
        <p className={styles.subHeading}>{subHeading}</p>
      </div>
    </div>
  )
}

export default EmptyResultsPlaceholder
